module.exports = __webpack_public_path__ + "ec71a9fea2728e7f5d130b1b4f52a4b8.svg";